import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { UTLabel, UTTouchableWithoutFeedback } from '@widergy/energy-ui';

import { ROUTES } from 'constants/routes';
import { actionCreators as authActions } from 'redux/authHandlers';
import { message } from 'utils/stringUtils';

import styles from './styles';

const ReturnToSignIn = ({ dispatch }) => {
  const handleSignOut = () => {
    dispatch(authActions.signOut());
    dispatch(push(ROUTES.SIGN_IN));
  };

  return (
    <UTTouchableWithoutFeedback key="signout" onClick={handleSignOut} style={styles.action}>
      <UTLabel semibold primary small>
        {message('Signup:returnToSignIn')}
      </UTLabel>
    </UTTouchableWithoutFeedback>
  );
};

export default connect()(ReturnToSignIn);
